import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'

const auth = namespace('auth')
const gtm = namespace('gtm')

/**
 * kakao login 페이지에서 로그인 후 리다이랙트 된 페이지 내부에서 query값으로 받은 code로 get kakao token을 수행
 * @mixin
 */
@Component
export default class GetKakaoTokenHandler extends Vue {
  /**
   * code
   * Code from redirecting oauth
   * kakao login page에서 redirect query 값으로 주는 code
   * getKakaoToken 요청 시 쓰임
   */
  @Prop({default: '', type: String}) code: string
  /**
   * then
   * After sign-in where to go
   * getKakaoToken 요청에 성공하면 replace할 페이지의 path
   * signInKakao 요청 시 state 값으로 보내야함
   */
  @Prop({default: '', type: String}) then: string

  @auth.Action('getKakaoToken') getKakaoToken: (payload: { code: string }) => Promise<void>
  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void

  /**
   * isUserDeniedAccess
   * Return true if route.query has access_denied error
   */
  get isUserDeniedAccess(): boolean {
    const {error, error_description} = this.$route.query || {}
    return error === 'access_denied' && error_description === 'User denied access'
  }

  @Watch('isUserDeniedAccess', {immediate: true})
  __isUserDeniedAccess(value) {
    if(value) {
      this.logEventWithGroups({
        eventType: 'error',
        eventProperties: {
          'error_type': 'access_denied',
          'workflow': 'sign_up',
        }
      })
    }
  }

  getKakaoTokenByCode(code) {
    return this.getKakaoToken({code})
  }

}
